// /* Bill.jsx */
// import { useState, useEffect } from "react";
// import axios from "axios";
// import { useParams, useNavigate } from "react-router-dom";
// import ApiUrl from "../Environment/ApiUrl";
// import "../../assets/css/Bill.css";

// export default function Bill() {
//   const { sales_no } = useParams();
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [salesData, setSalesData] = useState(null);
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (sales_no) {
//       fetchSalesData();
//     }
//   }, [sales_no]);

//   const fetchSalesData = async () => {
//     try {
//       setLoading(true);
//       console.log("Fetching for sales_no:", sales_no);

//       const response = await axios.get(
//         `${ApiUrl}/Api/sales.php?sales_no=${sales_no}`
//       );

//       console.log("API response:", response.data);

//       const filteredData = response.data.data?.find(
//         (item) => item.sales_no === sales_no
//       );
//       console.log("Filtered data:", filteredData);

//       if (filteredData) {
//         setSalesData(filteredData);
//       } else {
//         setError(`No sales data found for sales number: ${sales_no}`);
//       }
//     } catch (error) {
//       console.error("API error:", error);
//       setError("Failed to fetch sales data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // const fetchSalesData = async () => {
//   //   try {
//   //     setLoading(true);
//   //     const response = await axios.get(
//   //       `${ApiUrl}/Api/sales.php?sales_no=${salesNo}`
//   //     );
//   //     if (response.data?.data && response.data.data.length > 0) {
//   //       setSalesData(response.data.data[0]);
//   //     } else {
//   //       setError(`No sales data found for sales number: ${salesNo}`);
//   //     }
//   //   } catch (error) {
//   //     setError("Failed to fetch sales data");
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };

//   const numberToWords = (num) => {
//     const ones = [
//       "",
//       "One",
//       "Two",
//       "Three",
//       "Four",
//       "Five",
//       "Six",
//       "Seven",
//       "Eight",
//       "Nine",
//       "Ten",
//       "Eleven",
//       "Twelve",
//       "Thirteen",
//       "Fourteen",
//       "Fifteen",
//       "Sixteen",
//       "Seventeen",
//       "Eighteen",
//       "Nineteen",
//     ];
//     const tens = [
//       "",
//       "",
//       "Twenty",
//       "Thirty",
//       "Forty",
//       "Fifty",
//       "Sixty",
//       "Seventy",
//       "Eighty",
//       "Ninety",
//     ];

//     const numToWord = (n) => {
//       if (n < 20) return ones[n];
//       if (n < 100)
//         return (
//           tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + ones[n % 10] : "")
//         );
//       if (n < 1000)
//         return (
//           ones[Math.floor(n / 100)] +
//           " Hundred" +
//           (n % 100 !== 0 ? " and " + numToWord(n % 100) : "")
//         );
//       if (n < 100000)
//         return (
//           numToWord(Math.floor(n / 1000)) +
//           " Thousand" +
//           (n % 1000 !== 0 ? " " + numToWord(n % 1000) : "")
//         );
//       if (n < 10000000)
//         return (
//           numToWord(Math.floor(n / 100000)) +
//           " Lakh" +
//           (n % 100000 !== 0 ? " " + numToWord(n % 100000) : "")
//         );
//       return (
//         numToWord(Math.floor(n / 10000000)) +
//         " Crore" +
//         (n % 10000000 !== 0 ? " " + numToWord(n % 10000000) : "")
//       );
//     };

//     const decimalToWord = (decimalPart) => {
//       if (decimalPart === 0) return "";
//       const decStr = decimalPart.toString().padEnd(2, "0");
//       return " and " + numToWord(parseInt(decStr)) + " Paise";
//     };

//     const parts = num.toString().split(".");
//     const integerPart = parseInt(parts[0]);
//     const decimalPart =
//       parts.length > 1 ? parseInt(parts[1].padEnd(2, "0").substring(0, 2)) : 0;

//     let result = numToWord(integerPart) + " Rupees";
//     if (decimalPart > 0) {
//       result += decimalToWord(decimalPart);
//     }

//     return result;
//   };

//   const calculatePureTotal = (itemList) => {
//     if (!itemList || !Array.isArray(itemList)) return 0;
//     return itemList.reduce((total, item) => {
//       const weight = parseFloat(item.weight) || 0;
//       const purity = 0.945;
//       return total + weight * purity;
//     }, 0);
//   };

//   if (loading)
//     return <div className="flex justify-center p-4">Loading sales data...</div>;
//   if (error)
//     return <div className="flex justify-center p-4 text-red-500">{error}</div>;
//   if (!salesData)
//     return (
//       <div className="flex justify-center p-4">No sales data available</div>
//     );

//   const totalQuantity =
//     salesData.item_list?.reduce(
//       (total, item) => total + parseInt(item.quantity || 0),
//       0
//     ) || 0;
//   const totalWeight =
//     salesData.item_list?.reduce(
//       (total, item) => total + parseFloat(item.weight || 0),
//       0
//     ) || 0;
//   const purityValue = 94.5;
//   const pureWeight = calculatePureTotal(salesData.item_list);

//   const formatDate = (dateString) => {
//     if (!dateString) return "";
//     try {
//       const date = new Date(dateString);
//       return `${date.getDate().toString().padStart(2, "0")}-${(
//         date.getMonth() + 1
//       )
//         .toString()
//         .padStart(2, "0")}-${date.getFullYear()}`;
//     } catch (e) {
//       return dateString;
//     }
//   };

//   const receiptData = {
//     date: formatDate(salesData.sales_date),
//     // party: "SHEVAPET TIRUPPUR JEWELLERY",
//     product_code: "TJS-" + salesData.sales_no,
//     qty: totalQuantity,
//     weight: totalWeight,
//     purity: purityValue,
//     // fw: 0.0,
//     pure: pureWeight,
//     opening_pure: -0.313,
//     current_pure: pureWeight,
//     closing_pure: pureWeight - 0.313,
//     items: salesData.item_list || [],
//     subTotal: parseFloat(salesData.sub_total) || 0,
//     discount: parseFloat(salesData.discount) || 0,
//     netTotal: parseFloat(salesData.net_total) || 0,
//     paid: parseFloat(salesData.paid) || 0,
//     balance: parseFloat(salesData.balance) || 0,
//     paidInWords: numberToWords(parseFloat(salesData.paid) || 0),
//   };

//   const handlePrint = () => {
//     window.print();
//   };

//   const truncateText = (text, maxLength) => {
//     if (!text) return "";
//     return text.length > maxLength
//       ? text.substring(0, maxLength) + "..."
//       : text;
//   };
//   return (
//     <div className="receipt-container">
//       <button
//         className="cancel-btn no-print"
//         onClick={() => navigate("/sales")}
//       >
//         Cancel
//       </button>
//       {/* Thermal Receipt */}
//       <div className="receipt">
//         <div className="receipt-header">
//           <img
//             src={require("../../assets/images/Final logo c.png")}
//             alt="Company Logo"
//             className="receipt-logo"
//           />
//           <div className="receipt-title">Sales Estimate</div>
//         </div>
//         <div
//           className="receipt-info"
//           style={{ display: "flex", justifyContent: "space-justify" }}
//         >
//           <div>Date: {receiptData.date}</div>
//           <div className="billno">Bill No: {salesData.sales_no}</div>
//         </div>
//         {/* <div className="receipt-info">Party: {receiptData.party}</div> */}

//         <div className="receipt-divider"></div>

//         {/* Header row for items */}
//         <div
//           style={{
//             display: "flex",
//             width: "100%",
//             fontSize: "10px",
//             fontWeight: "bold",
//             marginLeft: "20px",
//           }}
//         >
//           <div style={{ width: "15%", textAlign: "left" }}>SNO</div>
//           <div style={{ width: "20%", textAlign: "left" }}>Product</div>
//           <div style={{ width: "15%", textAlign: "right" }}>Qty</div>
//           <div style={{ width: "19%", textAlign: "right" }}>Wgt</div>
//           {/* <div style={{ width: "18%", textAlign: "right" }}>Purity</div> */}
//           {/* <div style={{ width: "15%", textAlign: "right" }}>FW</div> */}
//           {/* <div style={{ width: "12%", textAlign: "right" }}>Pure</div> */}
//         </div>

//         <div className="receipt-divider"></div>

//         {/* Item rows */}
//         {receiptData.items.map((item, index) => (
//           <div
//             key={index}
//             style={{
//               display: "flex",
//               width: "95%",
//               fontSize: "10px",
//               marginLeft: "20px",
//             }}
//           >
//             <div
//               style={{ width: "15%", textAlign: "left", fontWeight: "bold" }}
//             >
//               {index + 1}
//             </div>
//             <div
//               style={{
//                 width: "20%",
//                 fontWeight: "bold",
//                 textAlign: "left",
//                 overflow: "hidden",
//                 textOverflow: "ellipsis",
//                 whiteSpace: "nowrap",
//               }}
//             >
//               {truncateText(item.item || "", 10)}
//             </div>
//             <div
//               style={{ width: "15%", textAlign: "right", fontWeight: "bold" }}
//             >
//               {item.quantity || ""}
//             </div>
//             <div
//               style={{ width: "23%", textAlign: "right", fontWeight: "bold" }}
//             >
//               {parseFloat(item.weight || 0).toFixed(2)}g
//             </div>

//             {/* <div
//               style={{ width: "18%", textAlign: "right", fontWeight: "bold" }}
//             >
//               {(0).toFixed(1)}
//             </div> */}
//           </div>
//         ))}

//         <div className="receipt-divider"></div>

//         {/* Total row */}
//         <div
//           style={{
//             display: "flex",
//             width: "95%",
//             fontSize: "10px",
//             marginLeft: "20px",
//           }}
//         >
//           <div style={{ width: "10%", textAlign: "left", fontWeight: "bold" }}>
//             Total
//           </div>
//           <div
//             style={{ width: "21%", textAlign: "left", fontWeight: "bold" }}
//           ></div>
//           <div style={{ width: "19%", textAlign: "right", fontWeight: "bold" }}>
//             {receiptData.qty}
//           </div>
//           <div style={{ width: "23%", textAlign: "right", fontWeight: "bold" }}>
//             {receiptData.weight.toFixed(2)}g
//           </div>
//           <div
//             style={{ width: "15%", textAlign: "right", fontWeight: "bold" }}
//           ></div>
//           <div
//             style={{ width: "10%", textAlign: "right", fontWeight: "bold" }}
//           ></div>
//         </div>

//         <div className="receipt-divider"></div>

//         {/* Pure and Amount header */}
//         <div
//           style={{
//             display: "flex",
//             width: "90%",
//             fontSize: "10px",
//             justifyContent: "center",
//           }}
//         >
//           <div
//             style={{ width: "40%", textAlign: "center", fontWeight: "bold" }}
//           >
//             Amount Summary
//           </div>
//         </div>

//         <div className="receipt-divider"></div>

//         {/* Summary rows */}
//         <div
//           style={{
//             display: "flex",
//             width: "85%",
//             fontSize: "10px",
//             marginLeft: "20px",
//           }}
//         >
//           <div style={{ width: "60%", textAlign: "left", fontWeight: "bold" }}>
//             Total
//           </div>
//           <div style={{ width: "40%", textAlign: "right", fontWeight: "bold" }}>
//             {receiptData.netTotal.toFixed(2)}
//           </div>
//         </div>

//         <div
//           style={{
//             display: "flex",
//             width: "85%",
//             fontSize: "10px",
//             marginLeft: "20px",
//           }}
//         >
//           <div style={{ width: "60%", textAlign: "left", fontWeight: "bold" }}>
//             Paid
//           </div>
//           <div style={{ width: "40%", textAlign: "right", fontWeight: "bold" }}>
//             {receiptData.paid.toFixed(2)}
//           </div>
//         </div>

//         <div
//           style={{
//             display: "flex",
//             width: "85%",
//             fontSize: "10px",
//             marginLeft: "20px",
//           }}
//         >
//           <div style={{ width: "60%", textAlign: "left", fontWeight: "bold" }}>
//             Balance
//           </div>
//           <div style={{ width: "40%", textAlign: "right", fontWeight: "bold" }}>
//             {receiptData.balance.toFixed(2)}
//           </div>
//         </div>

//         {/* Amount in words section */}
//         <div className="receipt-divider"></div>
//         <div
//           style={{
//             fontSize: "10px",
//             padding: "5px 20px ",
//             textAlign: "left",
//             fontWeight: "bold",
//           }}
//         >
//           Amount Paid In Words:
//         </div>
//         <div
//           style={{
//             fontSize: "10px",
//             padding: "0 20px 10px",
//             textAlign: "left",
//             fontStyle: "italic",
//           }}
//         >
//           {receiptData.paidInWords}
//         </div>

//         <div className="receipt-divider "></div>
//         <div className="receipt-footer page-break">
//           Thank you for your business!
//         </div>
//       </div>

//       <button onClick={handlePrint} className="print-button">
//         Print Receipt
//       </button>
//     </div>
//   );
// }





import { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import ApiUrl from "../Environment/ApiUrl";
import "../../assets/css/SalesBill.css";
import { useToast } from "../Toast/ToastContext";

export default function Bill() {
  const { sales_no } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();
  const toast = useToast();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [salesData, setSalesData] = useState(null);

  useEffect(() => {
    // Use passed state immediately (both estimate and just-saved bills)
    if (state?.salesData) {
      const sd = state.salesData;
      setSalesData({
        ...sd,
        item_list: (sd.item_list || []).map((item) => ({
          ...item,
          making_charges: item.making_charges ?? item.mc ?? "0",
          making_wastage: item.making_wastage ?? item.mw ?? "0",
          making_wastage_percentage: item.making_wastage_percentage ?? item.mw_percentage ?? "0",
        })),
      });
      setLoading(false);
    } else if (sales_no) {
      fetchSalesData();
    } else {
      setError("No sales data provided");
      setLoading(false);
    }
  }, [sales_no, state]);

  const fetchSalesData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${ApiUrl}/Api/sales.php?sales_no=${sales_no}`);
      const filteredData = response.data.data?.find((item) => item.sales_no === sales_no);
      if (filteredData) {
        setSalesData(filteredData);
      } else {
        setError(`No sales data found for sales number: ${sales_no}`);
      }
    } catch (error) {
      console.error("API error:", error);
      setError("Failed to fetch sales data");
      toast.error(`Failed to fetch sales data: ${error.response?.data?.message || error.message}`, 3000, "topRight");
    } finally {
      setLoading(false);
    }
  };

  const numberToWords = (num) => {
    if (isNaN(num) || num === null || num === undefined) return "";
    const ones = ["","One","Two","Three","Four","Five","Six","Seven","Eight","Nine","Ten","Eleven","Twelve","Thirteen","Fourteen","Fifteen","Sixteen","Seventeen","Eighteen","Nineteen"];
    const tens = ["","","Twenty","Thirty","Forty","Fifty","Sixty","Seventy","Eighty","Ninety"];
    num = parseFloat(num);
    if (num === 0) return "Zero Only";
    const conv = (n) => {
      if (n < 20) return ones[n];
      return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
    };
    let result = "";
    let intPart = Math.floor(num);
    const decimalPart = Math.round((num - intPart) * 100);
    if (intPart >= 100000) { result += conv(Math.floor(intPart / 100000)) + " Lakh "; intPart %= 100000; }
    if (intPart >= 1000)  { result += conv(Math.floor(intPart / 1000)) + " Thousand "; intPart %= 1000; }
    if (intPart >= 100)   { result += conv(Math.floor(intPart / 100)) + " Hundred "; intPart %= 100; }
    if (intPart > 0) result += conv(intPart);
    if (decimalPart > 0) result += " and " + conv(decimalPart) + " Paise";
    return result.trim() + " Only";
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const options = { year: "numeric", month: "short", day: "2-digit" };
    return date.toLocaleDateString("en-US", options);
  };

  const calculateTotals = () => {
    if (!salesData?.item_list) return { totalQty: 0, totalWeight: 0, totalAmount: 0, totalMaking: 0, totalWastage: 0 };
    return salesData.item_list.reduce(
      (acc, item) => {
        acc.totalQty    += parseInt(item.quantity) || 0;
        acc.totalWeight += parseFloat(item.weight) || 0;
        acc.totalAmount += parseFloat(item.amount) || 0;
        acc.totalMaking += parseFloat(item.making_charges) || 0;
        acc.totalWastage += parseFloat(item.making_wastage) || 0;
        return acc;
      },
      { totalQty: 0, totalWeight: 0, totalAmount: 0, totalMaking: 0, totalWastage: 0 }
    );
  };

  const handleBackToEdit = () => {
    if (state?.isEstimate && state?.restore) {
      navigate("/add-sales", { state: { restore: state.restore } });
    } else {
      navigate("/sales");
    }
  };

  if (loading) return <div className="d-flex justify-content-center p-4">Loading sales data...</div>;
  if (error)   return <div className="d-flex justify-content-center p-4 text-danger">{error}</div>;
  if (!salesData) return <div className="d-flex justify-content-center p-4">No sales data available</div>;

  const { totalQty, totalWeight, totalAmount, totalMaking, totalWastage } = calculateTotals();
  const formattedDate = formatDate(salesData.sales_date);
  const currentTime = new Date().toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true });

  const subTotal          = salesData.item_list?.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0) || 0;
  const discountPercentage = parseFloat(salesData.discount) || 0;
  const discountValue     = (subTotal * discountPercentage) / 100;
  const netTotalBeforeTax = subTotal - discountValue;
  const taxPercentage     = parseFloat(salesData.tax) || 0;
  const taxAmount         = (netTotalBeforeTax * taxPercentage) / 100;
  const roundOff          = parseFloat(salesData.round_off) || 0;
  const grandTotal        = netTotalBeforeTax + taxAmount + roundOff;

  // Gold & Silver rates
  const goldRate   = salesData.item_list?.find(i => (i.category || "").toLowerCase() === "gold")?.rate;
  const silverRate = salesData.item_list?.find(i => (i.category || "").toLowerCase() === "silver")?.rate;

  return (
    <div className="bill-container">
      <button className="print-btn no-print" onClick={() => window.print()}>
        Print Bill
      </button>
      <button className="cancel-btn no-print" onClick={handleBackToEdit}>
        {state?.isEstimate ? "Back to Edit" : "Cancel"}
      </button>

      {/* Header */}
      <div className="header-section d-flex justify-content-between align-items-center">
        <div className="logo-container">
          <img
            src={require("../../assets/images/Final logo c.png")}
            alt="TIRUPUR Logo"
            className="logo"
            style={{ width: "100px" }}
          />
        </div>
        <div className="company-info text-center">
          <h4 className="mb-1">TIRUPUR JEWELLERY</h4>
          <p className="mb-0">3/1, Thandan St, Shevapet, Salem, Tamil Nadu 636002</p>
          <p className="mb-0">Ph: 04272233807</p>
        </div>
        <div className="invoice-title">
          <p className="m-0 fw-bold">{state?.isEstimate ? "SALES ESTIMATE" : "SALES INVOICE"}</p>
        </div>
      </div>

      <hr className="divider" />

      {/* Customer + Invoice Info */}
      <div className="details-section">
        <div className="customer-info">
          <div className="customer-details">
            <p>{salesData.customer_data?.name || salesData.customer_name}</p>
            <p>{salesData.customer_data?.address || salesData.address}</p>
            <p>Cell: {salesData.customer_data?.mobile || salesData.mobile}</p>
            {salesData.tax && <p>Recipient GST: {salesData.tax}%</p>}
          </div>
        </div>
        <div className="invoice-info">
          <div className="info-row"><span>Date</span><span>: {formattedDate} / {currentTime}</span></div>
          <div className="info-row"><span>Bill No</span><span>: {salesData.sales_no}</span></div>
          {goldRate   && <div className="info-row"><span>Gold</span><span>: ₹{parseFloat(goldRate).toFixed(2)}/g</span></div>}
          {silverRate && <div className="info-row"><span>Silver</span><span>: ₹{parseFloat(silverRate).toFixed(2)}/g</span></div>}
        </div>
      </div>

      {/* Items Table */}
      <div className="table-section">
        <table className="bill-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Product</th>
              <th>Qty</th>
              <th>Weight(g)</th>
              <th>Rate</th>
              <th>Making</th>
              <th>Wastage</th>
              <th>GST</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {salesData.item_list?.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>
                  {item.item_name_tamil
                    ? `${item.item} / ${item.item_name_tamil}`
                    : item.item}
                  {item.category ? ` (${item.category})` : ""}
                </td>
                <td>{item.quantity}</td>
                <td>{parseFloat(item.weight || 0).toFixed(3)}</td>
                <td>{parseFloat(item.rate || 0).toFixed(2)}</td>
                <td>{parseFloat(item.making_charges || 0).toFixed(3)}</td>
                <td>{parseFloat(item.making_wastage || 0).toFixed(3)}</td>
                <td>{item.making_wastage_percentage ? `${item.making_wastage_percentage}%` : "-"}</td>
                <td>{parseFloat(item.amount || 0).toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="table-footer">
              <th colSpan="2">Total</th>
              <th>{totalQty}</th>
              <th>{totalWeight.toFixed(3)}</th>
              <th>-</th>
              <th>{totalMaking.toFixed(3)}</th>
              <th>{totalWastage.toFixed(3)}</th>
              <th>-</th>
              <th>{totalAmount.toFixed(2)}</th>
            </tr>
          </tfoot>
        </table>
      </div>

      {/* Totals + Terms */}
      <div className="details-section">
        <div className="customer-info">
          <div className="amount-in-words">
            <p>(Rupees: {numberToWords(grandTotal)})</p>
          </div>
          <p>*Terms &amp; Conditions</p>
          <p className="paragraph-cont">
            All jewellery items sold by Tirupur Jewellery are guaranteed to be
            genuine and accurately metal purity and gemstone specifications.
          </p>
        </div>
        <div className="invoice-info">
          <div className="totals-section">
            <div className="totals-grid">
              <div className="total-row"><span>Sub Total</span><span>{subTotal.toFixed(2)}</span></div>
              <div className="total-row"><span>Discount ({discountPercentage}%)</span><span>{discountValue.toFixed(2)}</span></div>
              <div className="total-row"><span>Net Amount</span><span>{netTotalBeforeTax.toFixed(2)}</span></div>
              <div className="total-row"><span>Tax ({taxPercentage}%)</span><span>{taxAmount.toFixed(2)}</span></div>
              <div className="total-row"><span>Round Off</span><span>{roundOff.toFixed(2)}</span></div>
              <div className="total-row highlight"><span>Grand Total</span><span>{grandTotal.toFixed(2)}</span></div>
              <div className="total-row"><span>Payment Type</span><span>{salesData.payment_history?.[0]?.payment_type || "N/A"}</span></div>
              <div className="total-row"><span>Paid</span><span>{parseFloat(salesData.paid || 0).toFixed(2)}</span></div>
              <div className="total-row"><span>Balance</span><span>{parseFloat(salesData.balance || 0).toFixed(2)}</span></div>
              {parseFloat(salesData.exchange_old_value || 0) > 0 && (
                <div className="total-row"><span>Exchange Old</span><span>{parseFloat(salesData.exchange_old_value).toFixed(2)}</span></div>
              )}
            </div>
          </div>
        </div>
      </div>

      <hr className="divider" />

      {/* Footer */}
      <div className="footer-section">
        <div className="signatures">
          <div className="customer-sign"><p>Signature of the Customer</p></div>
          <div>
            <p className="footer-notes">--- Thank You Visit Again ---</p>
            <div className="alaan"><p>Developed by Aalan Tech Soft - Salem</p></div>
          </div>
          <div className="company-sign">
            <p>FOR TIRUPUR JEWELLERY</p>
            <p>Authorized Signature</p>
          </div>
        </div>
      </div>
    </div>
  );
}
